import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Stages a card into the edit grid without a reload. The POST returns a turbo_stream that appends into
// #report-grid-cards, so unsaved edits are preserved. Uses request.js (not button_to) because admin has
// Turbo Drive off, so a plain form submit wouldn't be processed as a stream.
export default class extends Controller {
  static values = { url: String, showUrlTemplate: String };
  static targets = ["selectedChart", "addButton"];

  async addSection(event) {
    await this.stage({ variant: event.params.variant });
  }

  // The preview frame reloads with a target carrying the previewed chart's id; remember it and enable
  // the modal-footer Add chart button.
  selectedChartTargetConnected(element) {
    this.selectedChartId = element.dataset.chartId;
    if (this.hasAddButtonTarget) {
      this.addButtonTarget.disabled = false;
    }
  }

  // Fired when a preview link is clicked. Turbo keeps the old preview mounted until the new one loads,
  // so drop the stale selection and disable the button until selectedChartTargetConnected re-enables it.
  // Otherwise a quick Add chart during a slow preview load would act on the previously previewed chart.
  clearSelection() {
    this.selectedChartId = null;
    if (this.hasAddButtonTarget) {
      this.addButtonTarget.disabled = true;
    }
  }

  // :edit stages the previewed chart into the grid in place; :show has no live grid, so it navigates to
  // the edit page with the chart staged (showUrlTemplate carries a CHART_ID placeholder to substitute).
  addSelectedChart() {
    if (!this.selectedChartId) return;

    if (this.hasShowUrlTemplateValue && this.showUrlTemplateValue) {
      window.location.assign(
        this.showUrlTemplateValue.replace("CHART_ID", this.selectedChartId),
      );
    } else {
      this.stage({ massimo_chart_id: this.selectedChartId });
    }
  }

  async stage(body) {
    await post(this.urlValue, { body, responseKind: "turbo-stream" });
    this.dispatch("added");
  }
}
